<template xmlns:v-tooltip="http://www.w3.org/1999/xhtml">
  <div
    :data-index="index"
    :class="{ faded: card.is_removed === 1 }"
    class="list-group-item media"
    data-cy="list-item-card"
  >
    <div class="row">
      <!-- Avatar -->
      <div :class="{ 'col-xs-2': !compact, 'col-xs-1 compact-img': compact }">
        <a :href="cardDestinationUrl">
          <VLazyImage :src="avatar" class="img-circle" />
          <div
            v-if="card.is_contact"
            v-tooltip:top="$t('This profile is among your own freelance contacts.')"
            class="circle circle30 bgm-black contact-icon"
            style="line-height: 33px"
          >
            <i class="zmdi zmdi-account c-white f-20" />
          </div>
        </a>
        <div v-if="!isTypeJob && card.experience === 'stud'">
          <span class="label bgm-yellow c-white">{{ $t('Student') }}</span>
        </div>
      </div>
      <!-- Job Title / Freelancer Description -->
      <div :class="{ 'col-xs-10 col-sm-7': !compact, 'col-xs-11 col-sm-9': compact }">
        <h4 class="m-t-0 m-b-5" :class="{ 'compact-title': compact }">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <a :href="cardDestinationUrl" class="card-title" v-html="cardTitle" />
          <span
            v-if="card.association"
            class="label label-association f-13 p-t-0 p-b-0 f-400 label-default bgm-lightgray c-gray"
          >
            {{ $t(card.association + '.text') }}
          </span>
          <div v-if="card.is_removed === 1" class="pull-right">
            <WdsLabel sm error>
              {{ $t('Removed') }}
            </WdsLabel>
          </div>
        </h4>
        <!-- Company Name / Freelancer Name -->
        <component
          :is="profileUrl ? 'a' : 'span'"
          v-if="user !== ''"
          :href="profileUrl"
          target="_blank"
        >
          {{ cardName }}{{ location }}
        </component>
        <i
          v-if="card.is_available && !isTypeJob && isCompany"
          v-tooltip:top="
            $t('Available!') +
            '<br><small>' +
            $t('The freelancer has recently told us, that they’re available') +
            '</small>'
          "
          class="zmdi zmdi-calendar-check iblock c-black m-l-5"
        />
        <template v-if="showOwners && card.owners && card.owners.length > 0">
          <br />
          <small class="c-gray">
            {{ $t('Job owners') }}:
            {{
              card.owners.length === 1
                ? card.owners[0].name
                : card.owners.reduce((acc, o) =>
                    acc.name ? `${acc.name}, ${o.name}` : `${acc}, ${o.name}`,
                  )
            }}
            <a
              :href="
                laravelNamedRoute('yjob.custom-fields', {
                  yjob: card.id,
                })
              "
            >
              {{ $t('Change') }}
            </a>
          </small>
        </template>
        <span
          v-if="
            (filter.markets.selected.length !== 1 &&
              filter.markets.list &&
              Object.keys(filter.markets.list).length > 1 &&
              card.market) ||
            (recommended && card.market)
          "
          :class="{ pointer: recommended }"
          class="label circle circle-10 label-basic"
          @click="addMarketToSearch"
        >
          {{ card.market.toUpperCase() }}
        </span>

        <span
          v-if="showPublishDate && card.published_at"
          class="label f-13 p-t-0 p-b-0 f-400 label-default bgm-lightgray c-gray"
        >
          {{ $t('Published on') }}:
          {{ new Date(card.published_at).toLocaleDateString() }}
        </span>
        <div v-if="card.stars_html" class="row">
          <div>
            <div class="col-sm-4 col-xs-5">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span :title="$t('Rating based on company feedback')" v-html="card.stars_html" />
            </div>
          </div>
          <div v-if="card.num_taken_jobs" class="col-xs-6">
            <div>
              <span class="text-muted text-xs">{{ card.num_taken_jobs }} {{ $t('jobs') }}</span>
            </div>
          </div>
        </div>
        <div v-if="card.hasBusinessEntitySettingVisible" class="row">
          <div class="col-sm-6 small">
            <FreelancerBusinessSetup
              :country="card.country"
              :business-type="card.stringBasedOnBusinessType"
            />
          </div>
        </div>
      </div>
      <!-- Likes -->
      <div class="col-sm-1 col-xs-2 text-center">
        <span v-if="showLikes" class="heart">
          <ProfileLike :liked="liked" :card-type="type" :card-id="card.id" />
        </span>
      </div>
      <!-- Rate -->
      <div class="m-b-10 col-xs-12 visible-xs" />
      <div class="col-md-2 col-sm-12 col-xs-12 text-right">
        <template v-if="showRate">
          <div v-if="!hasJobs && !isTypeJob && isCompany">
            <span
              v-tooltip:top="
                $t(
                  'Once you have created a job, you will be able to view hourly rates on the freelancer.',
                )
              "
              class="iblock m-b-15 small c-gray"
            >
              {{ $t('Hourly rate hidden') }}
              <i class="zmdi zmdi-help" />
            </span>
          </div>
          <div v-else-if="card.hour_rate_display === '?' && isCompany">
            <span
              v-tooltip:top="
                $t(
                  'Once you have created a job, you will be able to view hourly rates on the freelancer.',
                )
              "
              class="iblock m-b-15 small c-gray"
            >
              {{ $t('Hourly rate hidden') }}
              <i class="zmdi zmdi-help" />
            </span>
          </div>
          <div v-else-if="rateType === 'daily' && card.daily_rate">
            <span class="lead f-18">
              <CurrencyDisplay
                :show-converted-rates-by-default="
                  Boolean($store.state.user.automatic_currency_conversion)
                "
                :currency-code="card.currency"
                :converted-currency-code="accountCurrency"
                :rate="
                  Number(
                    card.daily_rate
                      ? card.daily_rate
                      : calculateDailyRateFromHourly(card.hour_rate),
                  )
                "
                :show-currency-code="true"
              />
            </span>
            <div class="hidden-xs"></div>
            <small class="text-muted">
              {{ $t('rate.' + (card.ratetype || rateType) + '_slash') }}
            </small>
          </div>
          <div v-else-if="card.hour_rate || isTypeJob">
            <span class="lead f-18">
              <CurrencyDisplay
                :show-converted-rates-by-default="
                  Boolean($store.state.user.automatic_currency_conversion)
                "
                :currency-code="card.currency"
                :converted-currency-code="accountCurrency"
                :rate="Number(card.hour_rate || card.rate)"
                :range-from="card.rate_from ? Number(card.rate_from) : 0"
                :range-to="card.rate_to ? Number(card.rate_to) : 0"
                :show-currency-code="true"
              />
              <div class="hidden-xs"></div>
              <small class="text-muted">
                {{ $t('rate.' + (card.ratetype || rateType) + '_slash') }}
              </small>
            </span>
          </div>
          <div v-else>
            <span class="lead" />
            <small
              v-tooltip:top="$t('The freelancer has not chosen to set an hourly rate')"
              class="iblock c-gray m-b-15"
            >
              {{ $t('Hourly rate is not specified') }}
            </small>
          </div>
        </template>

        <div class="hidden-xs m-b-5" />

        <!--  Job Search -->
        <template v-if="isTypeJob">
          <div class="button-split">
            <ButtonSplit v-if="card.hires > 0" size="md">
              <template #default>
                <a
                  :href="cardDestinationUrl + (card.dialog ? '/dialog' : '')"
                  data-cy="list-item-card-link"
                >
                  {{ $t(viewJobButtonText) }}
                </a>
              </template>
              <template #dropdown>
                <ButtonSplitList>
                  <li>
                    <a
                      v-if="card.hires === 1"
                      :href="laravelNamedRoute('messages.show', { id: card.thread_id })"
                    >
                      {{ $t('Manage contract') }}
                    </a>
                    <a v-else :href="laravelNamedRoute('jobs.show.contracts', { job: card.id })">
                      {{ $t('Manage contract') }}
                    </a>
                  </li>
                </ButtonSplitList>
              </template>
            </ButtonSplit>

            <a
              v-else
              :href="cardDestinationUrl + (card.dialog ? '/dialog' : '')"
              data-cy="list-item-card-link"
            >
              <BaseButton>{{ $t(viewJobButtonText) }}</BaseButton>
            </a>
          </div>
        </template>

        <!--  Freelancer Search: signed in as a Company, has permission to contact  -->
        <template v-if="canContact">
          <div class="button-split">
            <ButtonSplit v-if="card.has_dialogs || card.is_contact" size="md">
              <template #default>
                <a :href="card.url_contact">{{ $t('Contact') }}</a>
              </template>

              <template #dropdown>
                <ButtonSplitList v-if="card.is_contact">
                  <li>
                    <a :href="'/profile/' + card.id + '/hire'">
                      <i class="zmdi zmdi-assignment-account" />
                      {{ $t('Hire') }}
                    </a>
                  </li>
                </ButtonSplitList>
                <ButtonSplitList v-if="card.has_dialogs">
                  <li class="header">
                    <a>{{ $t('Conversations with the freelancer') }}</a>
                  </li>
                  <li v-for="dialog in card.our_dialogs" :key="dialog.url">
                    <a :href="dialog.url">{{ dialog.linktext }}</a>
                  </li>
                </ButtonSplitList>
              </template>
            </ButtonSplit>

            <BaseButton v-else>
              <a :href="card.url_contact">
                {{ $t('Contact') }}
              </a>
            </BaseButton>
          </div>
        </template>
      </div>
    </div>
    <div class="m-b-10 col-xs-12 visible-xs" />
    <!-- Next Row -->
    <div class="row">
      <!-- Skills -->
      <div
        :class="{
          'col-sm-offset-2 col-sm-8 col-xs-12': !compact,
          'col-sm-offset-1 col-md-9': compact,
        }"
      >
        <div v-if="card.skills && showSkills" class="skills m-t-5">
          <a
            v-for="(skill, i) in skills"
            :key="i"
            :class="{
              'bgm-indigo': skill.is_keyword,
              'label-default': compact ? false : i <= 2,
              'bgm-purple': compact ? false : i <= 2 && !skill.is_keyword,
              'label-basic': compact ? true : i > 2 && !skill.is_keyword,
              'cursor-default': disableSkillsClick,
            }"
            class="label"
            @click="addSkillToSearch(skill)"
          >
            {{ skill.name }}
          </a>
          <a
            v-if="!compact && card.skills.length > 5 && skillsShown <= 5"
            href="#"
            class="label label-default"
            @click="showAllSkills(card.skills.length)"
          >
            +
            {{ $t(':count more', { count: card.skills.length - skillsShown }) }}
          </a>
        </div>
        <br v-if="card.badges" />
        <div v-if="card.badges" class="badges m-t-5">
          <!-- The colorshould be something like danger, default, primary, success and warning-->
          <WdsLabel
            v-for="(badge, i) in card.badges"
            :key="i"
            class="tw-mr-1.5"
            sm
            :subtle="badge.subtle"
            :[badge.color]="true"
          >
            {{ badge.value }}
          </WdsLabel>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import VLazyImage from 'v-lazy-image'
import { WdsLabel } from '@worksome/wds-components'
</script>

<script>
import BaseButton from '@/components/BaseButton.vue'
import ButtonSplit from '@/components/ButtonSplit.vue'
import ButtonSplitList from '@/components/ButtonSplitList.vue'
import ProfileLike from '@/components/ProfileLike.vue'
import CurrencyDisplay from '@/components/CurrencyDisplay.vue'
import FreelancerBusinessSetup from '@/components/FreelancerBusinessSetup.vue'
import { FILTER_MUTATIONS } from '@/state/mutation-types'
import enums from '@/utils/enum'
import FeatureFlagged from '@/components/FeatureFlagged.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'

export default {
  name: 'ListItemCard',
  components: {
    WdsLabel,
    ButtonSplit,
    ButtonSplitList,
    BaseButton,
    ProfileLike,
    CurrencyDisplay,
    FreelancerBusinessSetup,
    FeatureFlagged,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    parent: {
      type: Object,
      required: false,
      default: undefined,
    },
    recommended: {
      type: Boolean,
      required: false,
      default: false,
    },
    index: {
      type: Number,
      default: 1,
    },
    showPublishDate: {
      type: Boolean,
      default: false,
    },
    showOwners: {
      type: Boolean,
      default: false,
    },
    showSkills: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    type: {
      type: String,
      default: enums.cards.job,
    },
    avatarUrl: {
      type: String,
      default: undefined,
    },
    cardDestinationUrl: {
      type: String,
      default: undefined,
    },
    cardTitle: {
      type: String,
      default: undefined,
    },
    showRate: {
      type: Boolean,
      default: false,
    },
    showLikes: {
      type: Boolean,
      default: false,
    },
    location: {
      type: String,
      default: undefined,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    canContact: {
      type: Boolean,
      default: false,
    },
    cardName: {
      type: String,
      default: undefined,
    },
    disableSkillsClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skillsShown: 5, // how many skills shown by default
      updatingLike: false,
    }
  },
  computed: {
    avatar() {
      return this.avatarUrl ? this.avatarUrl : '/gfx/missing-logo.png?base'
    },
    profileUrl() {
      if (this.isTypeJob) {
        // Check if the current user is viewing their own company's jobs
        return this.account?.id === this.parent?.id
          ? `/profile/${this.parent.primary_profile_id}`
          : undefined
      }
      return this.cardDestinationUrl
    },
    accountCurrency() {
      return this.account?.currency ?? this.user.currency
    },
    hasJobs() {
      return this.isCompany && currentUserHasJobs
    },
    isCompany() {
      return this.account.isCompany
    },
    filter() {
      return this.$store.getters.filter
    },
    rateType() {
      return currentRateType || 'hourly'
    },
    isTypeJob() {
      // type === 'job' || 'profile'
      return this.type === enums.cards.job
    },
    skills() {
      if (this.card.skills_sorted) {
        return this.card.skills_sorted.slice(0, this.skillsShown - 1)
      }
      if (this.card.skills) {
        return this.card.skills.slice(0, this.skillsShown - 1)
      }
      return []
    },
    viewJobButtonText() {
      let text = ''
      if (this.card.dialog) {
        text = this.card.dialogs_count > 1 ? 'conversations' : 'conversation'
      } else {
        text = 'View job'
      }
      return text
    },
    liked() {
      return this.card.liked || this.card.liked_by_user
    },
  },
  methods: {
    addSkillToSearch(skill) {
      if (!this.filter.search.term.includes(skill.name) && !this.disableSkillsClick) {
        this.$store.commit(
          FILTER_MUTATIONS.SET_SEARCH_TERM,
          `${this.$store.state.filter.search.term},${skill.name}`,
        )
      }
    },
    addMarketToSearch() {
      if (!this.filter.markets.selected.includes(this.job.market)) {
        const selected = this.filter.markets.selected.concat([this.job.market])
        this.$store.commit(FILTER_MUTATIONS.MARKET_SELECTED, selected)
      }
    },
    calculateDailyRateFromHourly(hourlyRate) {
      return parseFloat(Math.max(0, parseFloat(hourlyRate) * 8).toFixed(2))
    },
    showAllSkills(numSkills) {
      this.skillsShown = numSkills
    },
  },
}
</script>

<style scoped lang="scss">
.faded {
  opacity: 0.6 !important;
}

.skills {
  .label {
    display: inline-block;
    padding-bottom: 0;
    padding-top: 0;
    margin-top: 0;
  }
}

.contact-icon {
  position: absolute;
  top: 30px;
  left: 50px;
  transform: scale(0.9);

  @media (max-width: 768px) {
    transform: scale(0.6);
    left: 30px;
    top: 15px;
  }
}

.compact-img img {
  max-width: 40px;
}

.compact-title {
  font-size: 18px;
  line-height: 1.2;
}

.label.label-association {
  margin: 0;
}

.card-title {
  cursor: pointer;
}

.button-split {
  float: right;
}

.cursor-default,
.cursor-default:hover {
  cursor: default;
}
</style>
